export enum LabProviderId {
  Quest = 4,
  LabCorp = 6,
  BioReference = 13,
}

export interface LabProviderInfo {
  name: string;
  schedulingUrl: string;
}

export const LAB_PROVIDER_MAP: Record<LabProviderId, LabProviderInfo> = {
  [LabProviderId.Quest]: {
    name: 'Quest Diagnostics',
    schedulingUrl: 'https://appointment.questdiagnostics.com/schedule-appointment/as-personal-information',
  },
  [LabProviderId.LabCorp]: {
    name: 'LabCorp',
    schedulingUrl: 'https://www.labcorp.com/patients',
  },
  [LabProviderId.BioReference]: {
    name: 'BioReference',
    schedulingUrl: 'https://www.bioreference.com/patients/locations-patient-services/find-a-location/',
  },
};

export function getLabProviderInfo(labId: number | undefined): LabProviderInfo | null {
  if (!labId || !(labId in LAB_PROVIDER_MAP)) {
    return null;
  }
  return LAB_PROVIDER_MAP[labId as LabProviderId];
}
